var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 7,
    viewBox: "0 0 22 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2652 4.01517C21.4116 3.86872 21.4116 3.63128 21.2652 3.48483L18.8787 1.09835C18.7322 0.951903 18.4948 0.951903 18.3483 1.09835C18.2019 1.2448 18.2019 1.48223 18.3483 1.62868L20.4697 3.75L18.3483 5.87132C18.2019 6.01777 18.2019 6.2552 18.3483 6.40165C18.4948 6.5481 18.7322 6.5481 18.8787 6.40165L21.2652 4.01517ZM0 4.125H21V3.375H0V4.125Z",
    fill: "#AE0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.cba9b0bfb523524537504264d1f3a4ac.svg";
export { ForwardRef as ReactComponent };